import { createIcon } from '@chakra-ui/icons';

export const CommentMultiple = createIcon({
  displayName: 'CommentMultiple',
  viewBox: '0 0 17 16',
  path: [
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4837 3.33203V10.6654C15.4837 11.019 15.3432 11.3581 15.0932 11.6082C14.8432 11.8582 14.504 11.9987 14.1504 11.9987H12.8171V14.6654L8.81706 11.9987H8.15039"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11.4837 1.33203H2.15035C1.79673 1.33203 1.45759 1.47251 1.20754 1.72256C0.957492 1.9726 0.817017 2.31174 0.817017 2.66536V7.9987C0.817017 8.35232 0.957492 8.69146 1.20754 8.94151C1.45759 9.19155 1.79673 9.33203 2.15035 9.33203H3.48368V12.6654L8.15035 9.33203H11.4837C11.8373 9.33203 12.1764 9.19155 12.4265 8.94151C12.6765 8.69146 12.817 8.35232 12.817 7.9987V2.66536C12.817 2.31174 12.6765 1.9726 12.4265 1.72256C12.1764 1.47251 11.8373 1.33203 11.4837 1.33203Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
